
export const fuelApiNm = {
  getFuel: "/fuel/getFuel",
  getFuel2: "/fuel/getFuel2",
  getFuelV2: "/fuel/getFuelV2",
  getFuelReport: "/fuel/getFuelReport",
  getMinMaxFuel: "/fuel/getMinMaxFuel",
  getFuelFileType: '/fuel/getFuelFileType',
  getMasterFuel: "/fuel/getMasterFuel",
  getLastMileStnEn: "/fuel/getLastMileStnEn",
  getLastMileTukEn: "/fuel/getLastMileTukEn",
  getFuelCost: "/fuel/getFuelCost",
  getCalculateJobWeight: "/fuel/getCalculateJobWeight",
  insertFuel: "/fuel/insertFuel",
  insertFuelV2: "/fuel/insertFuelV2",
  updateFuel: "/fuel/updateFuel",
  updateFuelV2: "/fuel/updateFuelV2",
  updateFuelCols: "/fuel/updateFuelCols",
  deleteFuel: "/fuel/deletefuel",
  uploadFile: "/fuel/uploadFile",
  updateFileName: "/fuel/updateFileName",
  updateFuelCostCol: "/fuel/updateFuelCostCol",
  updateFuelCostColBulk: "/fuel/updateFuelCostColBulk",
  deleteFile: "/fuel/deleteFile",
  addFuelPr: "/fuel/addFuelPr",
}

export const fuelColNm =  {
  FuelTyp: "ประเภทเชื้อเพลิง",
  FuelTm: "เวลาเติม",
  Mile: "เลขไมล์",
  FuelStnCd: "เลขหัวจ่าย",
  StnId: "เลขหัวจ่าย",
  MileTukSt: "ไมล์รถก่อนหน้า",
  MileTukEn: "เลขไมล์รถ",
  MileStnSt: "มิเตอร์หัวจ่ายก่อนเติม",
  MileStnEn: "มิเตอร์หัวจ่าย",
  MileLast: "ไมล์ก่อนหน้า",
  MileDiff: "ระยะทาง(กม.)",
  MileAdjPrct: "ปรับไมล์อ่อน(%)",
  MileAdjKm: "ปรับระยะทาง(กม.)/ระยะทาง GPS",
  RealMileDiff: "ระยะทางจริง(กม.)",
  Litr: "จำนวน(ลิตร)",
  Rate: "Rate (กม./ลิตร)",
  DrvId: "พนักงานขับรถ",
  DrvNNm: "พนักงานขับรถ",
  TukId: "เลขรถ",
  TukCd: "เลขรถ",
  GenId: "เลขเครื่อง Gen",
  GenCd: "เลขเครื่อง Gen",
  FuelPr: "ราคาเชื้อเพลิง",
  Amnt: "จำนวนเงิน",
  Rmk: "หมายเหตุ"
}

export const fuelCostColNm = {
  JobOrdId: "เลขที่ใบงาน",
  TakeLitr: "ลิตรรับ",
  LocLitr: "ลิตรส่ง",
  RtnLitr: "ลิตรคืน",
  GenLitr: "ลิตรเจน",
  TotalLitr: "รวมลิตร",
  TakePr: "ค่าน้ำมันรับ",
  LocPr: "ค่าน้ำมันรส่ง",
  RtnPr: "ค่าน้ำมันรคืน",
  GenPr: "ค่าน้ำมันเจน",
  TotalPr: "รวมค่าน้ำมัน",
}